const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @actions
const accountNewChequebookActions = require('actions/accountNewChequebook');
const printerActions = require('actions/contactCenter/printer');

// @components
import OKLayout from 'components/commons/OKLayout/OKLayout';
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountDetailsSideBar = require('components/accounts/accountDetailsSidebar/accountDetailsSidebar');
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountNewChequebookSuccess = require('components/accounts/accountNewChequebook/accountNewChequebookSuccess/accountNewChequebookSuccess');
const AccountNewChequebookForm = require('components/accounts/accountNewChequebook/accountNewChequebookForm/accountNewChequebookForm');
const WizardError = require('components/commons/wizardError/wizardError');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @commons
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @utilities
const { getLastNChars } = require('utilities/stringHelper');
const AccessHelper = require('utilities/accessHelper');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';

class AccountNewChequebookView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
    }
    componentDidMount() {
        const { history, match: { params: { accountId } }, immAccounts, requestAdditionalChequebookInformation } = this.props;
        AccessHelper.allowAccess(accountConstants.ACCOUNTS_NEW_CHEQUEBOOK, { immAccounts, accountId }, history);
        requestAdditionalChequebookInformation(accountId);
    }

    componentWillUnmount() {
        const { resetPrintedIndicators } = this.props
        resetPrintedIndicators()
    }

    buildError(accountId) {
        const errorTitle = formatText('accountNewChequebook-errorTitle');
        const errorMessage = formatText('accountNewChequebook-errorMessage');
        const goBackButtonLabel = formatText('accountNewChequebook-errorBackToChequesLink').toUpperCase();
        const linkToCheques = `/myprofile/accounts/${accountId}/cheques`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToCheques
        }
        return (
            <div className="row" >
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <OKSectionBox>
                        <WizardError
                            errorMessage={errorTitle}
                            errorSubMessage={errorMessage}
                            mainButton={goBackButton}
                        />
                    </OKSectionBox>
                </div>
            </div>
        );
    }

    isReady() {
        return false;
    }

    render() {
        const { match: { params: { accountId } }, immAccountNewChequebook, immAdditionalInformation, immAccounts, requestNewChequebook, clearAccountNewChequebook, immProfile } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);

        let bodyContent;
        if (immAdditionalInformation.get('inProgress')) {
            bodyContent = <LoadingSection />;
        } else if (immAccountNewChequebook.get('success')) {
            const accountAlias = immAccount.get('alias');
            bodyContent = (
                <div className="row" >
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <AccountNewChequebookSuccess
                            accountId={accountId}
                            accountAlias={accountAlias}
                            clearAccountNewChequebook={clearAccountNewChequebook}
                            immProfile={immProfile}
                        />
                    </div>
                </div>
            );
        } else if (immAdditionalInformation.get('errorMessage')) {
            bodyContent = this.buildError(accountId);
        } else {
            const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
            const cancelText = formatText('wizard-redirectConfirmationCancelButton');
            const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
            const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

            bodyContent = (
                <div className="row" >
                    <div className="col-xs-12 col-md-8" id="printable-wizard">
                        <PreLeaveModalComponent
                            confirmationMessage={confirmationMessage}
                            confirmationTitle={confirmationTitle}
                            acceptText={acceptText}
                            cancelText={cancelText}
                            isReady={this.isReady}
                        />
                        <AccountNewChequebookForm
                            accountId={accountId}
                            immAccounts={immAccounts}
                            immAccountNewChequebook={immAccountNewChequebook}
                            immAdditionalInformation={immAdditionalInformation}
                            requestNewChequebook={requestNewChequebook}
                        />
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        <AccountDetailsSideBar immAccount={immAccount} />
                    </div>
                </div>
            );
        }


        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-chequebook'),
                url: `/myprofile/accounts/${accountId}/cheques`
            },
            {
                text: formatText('breadcrumb-newChequebook'),
                url: ''
            }
        ];
        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                buttons={<AccountMoreOptionsButton accountId={accountId} />}
                contentPosition={NEGATIVE}
                title={getFinalTitle('accountNewChequebook-viewTitle')}
                loading={!immAccount}
                section="accounts"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
            >
                {bodyContent}
            </OKLayout>
        )
    }
}

AccountNewChequebookView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immAccountNewChequebook: PropTypes.object.isRequired,
    immAdditionalInformation: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestNewChequebook: PropTypes.func,
    clearAccountNewChequebook: PropTypes.func,
    requestAdditionalChequebookInformation: PropTypes.func,
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired
};

module.exports.constructor = AccountNewChequebookView;
module.exports.AccountNewChequebookView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountNewChequebook: state.accountNewChequebook,
        immAdditionalInformation: state.accountChequebookAdditionalInformation,
        immProfile: state.profile
    }), {
    requestAdditionalChequebookInformation: accountNewChequebookActions.requestAdditionalChequebookInformation,
    resetPrintedIndicators: printerActions.resetPrintedIndicators,
    requestNewChequebook: accountNewChequebookActions.requestNewChequebook,
    clearAccountNewChequebook: accountNewChequebookActions.clearAccountNewChequebook
}
)(withRouter(AccountNewChequebookView));
